import { SupplierCustomerRegistry } from '../interfaces/supplierCustomerRegistry';


export class SupplierCustomerRegistryModel implements SupplierCustomerRegistry {
    ArcadCode: null;
    Bis770 : string;
    BrandCode: string;
    CLIENTCODE: string;
    COMPANYCODE: string;
    CUSTOMERCODE: string;
    Causal770: string;
    CausalCode: string;
    CommonCustomerRegistry: string;
    LastPurchaseDate: string;
    NationCode: string;
    PhysicalPerson: boolean;
    RevocaDate:  string;
constructor() { }
}
